/**
 * Strip a raw input string down to a valid decimal-currency string:
 * remove non-numeric chars (except the decimal point), pad a leading
 * decimal to `0.x`, and clamp to 2 decimal places.
 *
 * Pure function — no component coupling. Shared by `Currency` and
 * `FormInputChargeableCancellation` so the strip logic lives in one place.
 */
export const stripDecimalString = (input: string): string => {
  // Remove any non-numeric characters except the decimal point
  let value = input.replace(/[^\d.]/g, '');

  // Handle leading decimal point
  if (value.startsWith('.')) {
    value = `0${value}`;
  }

  // Split on decimal point
  const parts = value.split('.');

  // Restrict to 2 decimal places
  if (parts.length > 2 || (parts[1] && parts[1].length > 2)) {
    value = `${parts[0]}.${parts[1] ? parts[1].substring(0, 2) : ''}`;
  }

  return value;
};
